/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Danger_ZoneInputs */

const en_ui_data_danger_zone = /** @type {(inputs: Ui_Data_Danger_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

const de_ui_data_danger_zone = /** @type {(inputs: Ui_Data_Danger_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefahrenzone`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Ui_Data_Danger_ZoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_danger_zone = /** @type {((inputs?: Ui_Data_Danger_ZoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Danger_ZoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_danger_zone(inputs)
	return de_ui_data_danger_zone(inputs)
});